import React, { Component } from 'react';

import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

//Common UI
import './App.css';

import TextField from '@material-ui/core/TextField';
import Fab from '@material-ui/core/Fab';

//Icons
import LockIcon from '@material-ui/icons/LockOpen';

//App Classes & Network Calls
import Dashboard from './components/DashBoard';

import store from './store_actions/UserStore';
import { DoLogin, DoLogout } from './store_actions/UserActions';
import { Grid, Button } from '@material-ui/core';
import Snackbar from '@material-ui/core/Snackbar';

//Style Sheet
const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#F7F7F7',
    height: window.innerHeight,
  },

  login: {
    flexDirection: 'column',
    display: 'flex',
    marginTop: window.innerHeight / 10,
    width: 400,
    justifyContent: 'center',
    alignItems: 'center',
  },
  form: {
    flexDirection: 'column',
    width: '100%',
  },
  avatar: {
    width: 120,
    height: 120,
    alignSelf: 'center',
  },
  logo: {
    width: 100,
    height: 100,
    marginTop: 50,
  },
  btnPrimary: {
    backgroundColor: '#4c21af',
    width: '80%',
    alignSelf: 'center',
    borderRadius: 30,
    height: 50,
    marginTop: 30,
    marginBottom: 5,
  },
  btnLabel: {
    fontSize: 16,
    color: '#FFF',
  },
  textView: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 30,
    flexDirection: 'row',
    backgroundColor: '#FFF',
    alignSelf: 'center',
    height: 48,
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 5,
    paddingBottom: 10,
    marginTop: 10,
    marginBottom: 10,
    width: 300,
  },
});

class App extends Component {
  constructor(props) {
    super(props);

    this.makeChanges = this.makeChanges.bind(this);
    this.didLogout = this.didLogout.bind(this);
    this.showError = this.showError.bind(this);
    this.state = {
      isLogin: false,
      user: store.viewUser(),
      appSecret: '',
      currentUser: [],
      pass_code: '',
      user_id: '',
      error: '',
      open: false,
    };
  }

  didLogout() {
    // localStorage.setItem('app_token', null);
    this.setState({ isLogin: false });
    DoLogout();
  }

  onTapLogin = () => {
    const { user_id, pass_code } = this.state;
    if (user_id.length > 3 && pass_code.length > 3) {
      DoLogin({ user_id, pass_code });
    } else {
      alert('Please provide a Valid User ID and Password');
    }
  };

  makeChanges() {
    this.setState({
      user: store.viewUser(),
    });
  }

  showError() {
    this.setState({
      error: store.error,
      open: true,
    });
    setTimeout(() => {
      this.setState({
        open: false,
      });
    }, 3000);
  }

  componentWillMount() {
    store.on('login', this.makeChanges);
    store.on('error', this.showError);
  }

  render() {
    const { classes } = this.props;

    const { user } = this.state;

    if (user === undefined) {
      return (
        <div className={classes.root}>
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={this.state.open}
            autoHideDuration={4000}
            onClose={this.handleClose}
            ContentProps={{
              'aria-describedby': 'message-id',
            }}
            message={
              <span id="message-id" style={{ color: 'red' }}>
                {this.state.error}
              </span>
            }
          ></Snackbar>
          <Grid container>
            <Grid item xs={1} sm={1}></Grid>
            <Grid item xs={8} sm={3}>
              <img
                src={require('./images/logo.png')}
                className={classes.logo}
              />
            </Grid>
          </Grid>
          <Grid container direction="row" justify="center" alignItems="center">
            <div className={classes.login}>
              <img
                src={require('./images/admin_logo.png')}
                className={classes.avatar}
              />
              <label
                style={{
                  fontSize: 20,
                  alignSelf: 'center',
                  color: '#505050',
                  marginTop: 20,
                  marginBottom: 20,
                  fontWeight: 'bolder',
                }}
              >
                DYC Admin Login
              </label>
              <div className={classes.textView}>
                <TextField
                  onChange={(e) => {
                    this.setState({ user_id: e.target.value });
                  }}
                  style={{ width: '100%', display: 'flex' }}
                  placeholder="Email ID"
                  InputProps={{ disableUnderline: true }}
                />
              </div>

              <div className={classes.textView}>
                <TextField
                  onChange={(e) => {
                    this.setState({ pass_code: e.target.value });
                  }}
                  style={{ width: '100%', display: 'flex' }}
                  placeholder="Password"
                  type="password"
                  InputProps={{ disableUnderline: true }}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      this.onTapLogin();
                    }
                  }}
                />
              </div>

              <Button
                className={classes.btnPrimary}
                onClick={() => this.onTapLogin()}
              >
                <label className={classes.btnLabel}>Login</label>
              </Button>
            </div>
          </Grid>
        </div>
      );
    } else {
      return <Dashboard onLogout={this.didLogout} currentUser={user} />;
    }
  }

  //========================= UTILITY ===============================

  //ALERT
  onDismiss = () => {
    this.setState({ showAlert: false });
  };

  onOkay = () => {
    this.setState({ showAlert: false });
  };
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(App);

//	"homepage": "/beta/",
